export default function Loading({ children }: { children?: React.ReactNode }) {
  return (
    <div
      css={{
        width: 300,
      }}
    >
      {children}
      <div
        css={{
          position: 'relative',
          width: '100%',
          height: 2,
          background: '#f7f7f7',
          overflow: 'hidden',
          borderRadius: 10,
          marginTop: 20,
          '&:before': {
            content: '""',
            background: '#ff3b00',
            width: 80,
            height: '100%',
            zIndex: 1,
            position: 'absolute',
            transform: 'translate(0, 0)',
            animation: 'moving 2s infinite',
            borderRadius: 10,
          },
        }}
      />
    </div>
  );
}
